var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-header',{attrs:{"title":_vm.title}},[_c('q-btn',{attrs:{"to":{ name: _vm.routes.priceConfigCreate },"unelevated":"","color":"primary","no-caps":"","no-wrap":"","label":"Добавить доставку"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }